window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.flatpickr').length) {
    import('./_datepicker.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
